import { SGB_PRODUCT_DETAILS, SGB_PRODUCT_ERROR, SGB_PRODUCT_HIDE_ERROR, SGB_PRODUCT_STOP_LOADER, SGB_PRODUCT_START_LOADER, } from "../interface/iSGBProductDetails";
const initState = {
    data: [],
    sgbLoader: false,
    errorData: {
        erorr: null,
        isOpen: false,
    },
};
const sgbProductDetailsReducer = (state = initState, action) => {
    switch (action.type) {
        case SGB_PRODUCT_DETAILS:
            return Object.assign(Object.assign({}, state), { data: action.payload.data });
        case SGB_PRODUCT_ERROR:
            return Object.assign(Object.assign({}, state), { errorData: action.payload.errorData });
        case SGB_PRODUCT_HIDE_ERROR:
            return Object.assign(Object.assign({}, state), { errorData: initState.errorData });
        case SGB_PRODUCT_START_LOADER:
            return Object.assign(Object.assign({}, state), { sgbLoader: true });
        case SGB_PRODUCT_STOP_LOADER:
            return Object.assign(Object.assign({}, state), { sgbLoader: false });
        default:
            return Object.assign({}, state);
    }
};
export default sgbProductDetailsReducer;
